import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import { darkGray } from "../../../common/helpers/colors";

function OrphanetLink({ id }) {
  const url = `https://www.orpha.net/consor/cgi-bin/OC_Exp.php?lng=EN&Expert=${id}`;

  return id ? (
    <a
      href={getVarsoUrl(url)}
      target="_blank"
      style={{ color: darkGray }}
      className="tw-rounded tw-px-1 tw-ml-1"
      title="View on Orphanet"
    >
      Orphanet
      <i style={{ color: darkGray }} className="fa fa-external-link tw-pl-1" />
    </a>
  ) : null;
}

OrphanetLink.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default OrphanetLink;
